import React, { useRef } from 'react'
import { TextArea } from '@progress/kendo-react-inputs';
import { FieldWrapper } from '@progress/kendo-react-form';
import LabelPure from '../../../../pures/label/label.pure';
import { Error, Hint } from '@progress/kendo-react-labels';

function TextAreaWrapper(fieldRenderProps) {
    const {
        touched,
        label,
        id,
        valid,
        hint,
        validationMessage,
        maxLength,
        rows,
        ...others
    } = fieldRenderProps;

    const editorRef = useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";

    return (
        <FieldWrapper className={`textareaWrapper ${showValidationMessage ? "textareaWrapper-error" : ""}`}>
            <LabelPure
                id={labelId}
                editorId={id}
                className="k-form-label"
                title={label}
            />
            <div className={"k-form-field-wrap"}>
                <TextArea
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    ref={editorRef}
                    id={id}
                    fillMode="flat"
                    autoSize
                    rows={rows || 2}
                    validationMessage={validationMessage}
                    valid={!showValidationMessage}
                    {...others}
                    maxLength={maxLength || 100}
                />
                {showHint && <Hint id={hintId}>{hint}</Hint>}
                {showValidationMessage && (
                    <Error id={errorId}>{validationMessage}</Error>
                )}
            </div>
        </FieldWrapper>
    )
};

export default TextAreaWrapper